import { render, staticRenderFns } from "./TableTreeItem.vue?vue&type=template&id=3257ff60&"
import script from "./TableTreeItem.vue?vue&type=script&lang=js&"
export * from "./TableTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports